"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiniBag = void 0;
var _mui = require("@ori-ui/mui");
var _basketItem = require("@ori/basket-item");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _Footer = require("../Footer");
var _FormattedMessage = require("../FormattedMessage");
var _Header = require("../Header");
var _LoadingOverlay = require("../LoadingOverlay");
var _SectionItem = require("../SectionItem");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MiniBag = ({
  breakpointIndex,
  items,
  itemsX,
  isConsultant,
  isDiscounted,
  isDataLoaded,
  isLoading,
  basketItemTranslations,
  basketItemTranslationsNamespace,
  onMouseEnter,
  onMouseLeave,
  useOpenedMinibagOnDesktop
}) => {
  const quantity = items.reduce((total, current) => total + current.requestedQuantity, 0);
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const ownerState = {
    breakpointIndex,
    useOpenedMinibagOnDesktop
  };
  const rootProps = {
    onMouseEnter,
    onMouseLeave,
    ownerState,
    ...getTestIdProps('content')
  };
  const sectionMiniBagProps = (0, _react.useMemo)(() => ({
    basketItemTranslations,
    basketItemTranslationsNamespace,
    isConsultant,
    isDiscounted
  }), [basketItemTranslations, basketItemTranslationsNamespace, isConsultant, isDiscounted]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    ...rootProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {
      quantity: quantity
    }), isLoading || !isDataLoaded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingOverlay.LoadingOverlay, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ItemsWrapper, {
      ...getTestIdProps('items'),
      children: [items.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Items, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_basketItem.BasketSection, {
          isSmall: true,
          children: items.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionItem.SectionItem, {
            item: item,
            sectionMiniBagProps: sectionMiniBagProps,
            itemsX: itemsX
          }, `minibag-item-${item.lineNumber}-${item.itemCode}-${item.itemType}-${item.totalPrice}`))
        })
      }), isDataLoaded && items.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.EmptyBag, {
        ...getTestIdProps('empty'),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h6",
          component: "p",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "emptyBag"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
          children: ["- ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "emptyBagMessage"
          }), " -"]
        })]
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.Footer, {})]
  });
};
exports.MiniBag = MiniBag;
